
export default interface IBankRole {
    roleID?: number ,
    roleName?: string,
    roleDescription?: string,
    
    roleItems: IBankRoleItem[]
  }

  export interface IFormAction {
    formCode: string;
    name: string, 
    description: string
  }

  export interface IBankRoleItem {
    formCode: string,
    formName: string,
    canCreate: boolean,
    canRetreive: boolean,
    canUpdate: boolean,
    canDelete: boolean,
    canPrint: boolean,
    canMergeDoc: boolean,
    canAttachDoc: boolean,
    canWorkflow: boolean,
    canAuthorize: boolean,
    //formActions: string[]
    formAction: string,
    formActions: IFormAction[]
  }



  

  export interface IFormDef {
    formCode: string,
    formName: string,

    formActions: IFormAction[]
  }

  export const defaultBankRole: IBankRole = {
    roleID: 0,
    roleName: '',
    roleDescription: '',  
    
    roleItems: Array<IBankRoleItem>(0)
 }
